import { render, staticRenderFns } from "./setting-emailsignature.vue?vue&type=template&id=7d464128&scoped=true&"
import script from "./setting-emailsignature.vue?vue&type=script&lang=js&"
export * from "./setting-emailsignature.vue?vue&type=script&lang=js&"
import style0 from "./setting-emailsignature.vue?vue&type=style&index=0&id=7d464128&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d464128",
  null
  
)

export default component.exports